import React from 'react';

import './imageryUsageComponent.scss'

class ImageryUsageComponent extends React.Component {
    render() {
        return <div className="introduction-component">
            <div className="section">
                <p>Life Fitness product images are to be used only when specifically referencing Life Fitness equipment. For example, an image of a Life Fitness treadmill should never be used to represent another fitness manufacturer.</p>
            </div>

            <br />
            <div className="section">
                <h3>INTEGRITY SERIES WITH X CONSOLE</h3>
                <iframe title="INTEGRITY SERIES WITH X CONSOLE" src="https://lifefitness.widencollective.com/c/9kcowhsw" scrolling="no" width="940" height="500" frameBorder="0" />
            </div>

            <br />
            <div className="section">
                <h3>ELEVATION SERIES WITH SE3HD CONSOLE</h3>
                <iframe title="ELEVATION SERIES WITH SE3HD CONSOLE" src="https://lifefitness.widencollective.com/c/xlooi6sm" scrolling="no" width="940" height="700" frameBorder="0" />
            </div>
        </div>
    }
}

export default ImageryUsageComponent



// WEBPACK FOOTER //
// ./src/components/marketingGuidelines/marketingComponents/ImageryUsage/ImageryUsageComponent.js